import React from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import Box from '@mui/material/Box';
import AppStoreBadges from './components/AppStoreBadges';
import FooterSocialLinks from './components/FooterSocialLinks';
import { footerColumnTitleSx } from './components/footerSectionStyles';
import CccLogo from './assets/ccc-logo.png';
import RaisedByNature from './assets/raised-by-nature.png';
import FooterLogo from './assets/lan-footer.png';
import FooterBg from './assets/footer-bg.png';
import { useContext } from 'react';
import { CommonContext } from './contexts/CommonContext';
import { useNavigate } from 'react-router-dom';
import { color } from 'framer-motion';
import FooterImage from './assets/Group76.png';
import { height, width } from '@mui/system';
const styles = {
  whyccc: {
    color:'#FFF0D9',
    display:'flex',
    padding:'2vw',
    textAlign:'center',
    flexDirection:'column',
    background:'#a4243d', 
    backgroundSize:'cover',
    padding:'80px 0 10px 0px'
  },
  whycccDesk : {
    color:'#000',
    display:'flex',
    padding:'2vw',
    textAlign:'center',
    flexDirection:'column',
    background:`url(${FooterBg})`, 
    backgroundSize:'cover',
    padding:'80px 0 0 0',
    minHeight:'auto'
  },
  contentCont: {
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    display: 'flex',
    position: 'relative'
  },
  footerImage:{
position:"relative",
margin:'10px',
width:'80%',
  },
  footerImageCont:{
    position:"relative",
    margin:'10px',
    width:'30%',
  },
  extraImg: {
    maxHeight: '120px',
    marginBottom: '20px',
    maxWidth: '350px'
  },
  title:{
    fontSize:'1rem', fontWeight:'400', marginBottom:'10px', textAlign:'start', marginLeft:'4vw',textDecoration: 'underline',fontFamily:'Foregen'
  }
};

function Footer() {
  const navigate = useNavigate();
  const { isDesktop } = useContext(CommonContext);

  return (
    <Box style={isDesktop ? styles.whycccDesk : styles.whyccc}>
      <Grid container spacing={2} sx={{ width: '100%', display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'space-between',
    width: '100%', }}>
        
        {/* First Row */}
        <Grid  sm={4} md={6} lg={6}>
        <div style={styles.contentCont}>
          <Box sx={{display:'flex', flexDirection:'column'}}>
            <Box sx={{fontSize:'1rem', fontWeight:'400', marginBottom:'10px', textAlign:'start', marginLeft:'6vw',textDecoration: 'underline',fontFamily:'Foregen'}}>
              Our Products
            </Box>
            <Box sx={{marginLeft:'6vw', fontSize:isDesktop? '15px':'11px',fontWeight:'400',fontFamily:'Roboto',cursor:'pointer'}}>
              <Box sx={{display:'flex', alignItems:'center', marginBottom:'10px'}}
                onClick={() => navigate('products/better-than-broiler-chicken')}>
                Better Than Broiler Chicken
              </Box>
              <Box sx={{display:'flex', alignItems:'center', marginBottom:'10px'}}
                onClick={() => navigate('products/tender-country-chicken')}>
                Tender Country Chicken
              </Box>
              <Box sx={{display:'flex', alignItems:'center', marginBottom:'10px',}}
                onClick={() => navigate('products/classic-country-chicken')}>
                Classic Country Chicken
              </Box>
              <Box sx={{display:'flex', alignItems:'center', marginBottom:'10px'}}
                onClick={() => navigate('/categories/mutton')}>
                 Country Mutton
              </Box>
              <Box sx={{display:'flex', alignItems:'center', marginBottom:'10px'}}
                onClick={() => navigate('products/young-warrior')}>
                Warrior Country Chicken
              </Box>
              <Box sx={{display:'flex', alignItems:'center', marginBottom:'10px'}}
                onClick={() => navigate('categories/pickles')}>
                Non-Veg Pickles
              </Box>
              <Box sx={{display:'flex', alignItems:'center', marginBottom:'10px'}}
                onClick={() => navigate('products/brown-eggs-6pack')}>
                Eggs
              </Box>
              <Box sx={{display:'flex', alignItems:'center', marginBottom:'10px'}}
                onClick={() => navigate('categories/Amma-Chethi-Marinades')}>
                Marinades
              </Box>
            </Box>
            <Box sx={{ mt: { xs: 3, md: 4 }, marginLeft: '6vw' }}>
              <Box sx={footerColumnTitleSx}>Download Our App</Box>
              <AppStoreBadges sx={{ justifyContent: 'flex-start' }} />
            </Box>
          </Box>
        </div>
      </Grid>

      <Grid  sm={4} md={6} lg={6}>
        <div style={styles.contentCont}>
          <Box sx={{display:'flex', flexDirection:'column'}}>
            <Box sx={{fontSize:'1rem', fontWeight:'400', marginBottom:'10px',lineHeight:'22.7px', textAlign:'start', marginLeft:'4vw',fontFamily:'Foregen',textDecoration: 'underline'}}>
            Know Us
            </Box>
            <Box sx={{marginLeft:'4vw' , fontSize:isDesktop? '15px':'11px',fontWeight:'400'}}>
              <Box sx={{display:'flex', alignItems:'center', marginBottom:'10px', cursor:'pointer'}}
                onClick={() => navigate('/aboutUs')}>
                Our Story
              </Box>
              <Box sx={{display:'flex', alignItems:'center', marginBottom:'10px', cursor:'pointer'}}
                onClick={() => navigate('/contactUs')}>
                Contact Us
              </Box>
              <Box sx={{display:'flex', alignItems:'center', marginBottom:'10px', cursor:'pointer'}}
                onClick={() => navigate('/termsAndConditions')}>
                Terms And Conditions
              </Box>
              <Box sx={{display:'flex', alignItems:'center', marginBottom:'10px', cursor:'pointer'}}
                onClick={() => navigate('/privacyPolicy')}>
                Privacy Policy
              </Box>
              <Box sx={{display:'flex', alignItems:'center', marginBottom:'10px', cursor:'pointer'}}
                onClick={() => navigate('/refundPolicy')}>
                Cancellation / Refund Policy
              </Box>
            </Box>
            <Box sx={{ mt: { xs: 3, md: 4 }, marginLeft: '4vw' }}>
              <FooterSocialLinks />
            </Box>
          </Box>
        </div>
      </Grid>

        <Grid sx={{width :'100%'}}>
          <Box >
        <img src={FooterImage} alt="Footer Image" style={isDesktop ? styles.footerImageCont: styles.footerImage } />
           
          </Box>
        </Grid>
      </Grid>
      
    </Box>
  );
}

export default Footer;
